import { AdminUserOperatorView } from '../../components/admin/asignaciones-usuario-operador/AdminUserOperatorView';
import { useAuth } from '../../hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ===============================
// VISTA DE ADMINISTRACIÓN - CONTROL DE USUARIOS Y OPERADORES
// ===============================

export function AdminUsuariosOperadoresView() {
  const { t } = useTranslation();
  const { isSuperuser, isLoading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  // Redirigir si no es superuser
  if (!isSuperuser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <AdminUserOperatorView />
      </div>
    </div>
  );
}
